import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import Spinner from "Common/Globle/Spinner";
import { validateForm } from "utils/validation";
import { ContactInformationRules } from "validation/ValidationRules";
import { GetById, Update } from "adminApi/ContactInformation/ContactInformation";
import useFormChange from "Hooks/useFormChange";
import useFormSubmit from "Hooks/useFormSubmit";
import useFetchFormDataById from "Hooks/useFetchFormDataById";
import fields from "../json/ContactInformationFields.json";
import EditContactInformationForm from "./Componates/EditContactInformationForm";

const EditContactInformation = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const { formdata } = fields;

  // Initialize form values
  const initialValues = formdata.reduce((acc, field) => ({ ...acc, [field.name]: "" }), {});

  // Manage input change
  const { values, errors, handleChange, setErrors, setValues } = useFormChange(initialValues, ContactInformationRules);

  // Fetch existing contact info by ID
  const { loading: loadingFetch } = useFetchFormDataById(id, formdata, GetById, setValues);

  // Form submit handler
  const { loading: loadingSubmit, handleSubmit } = useFormSubmit(
    async (formValues) => {
      return await Update({id,data:formValues});
    },
    (vals) => {
      const err = validateForm(vals, ContactInformationRules);
      setErrors(err);
      return err;
    },
    () => navigate(-1),
    "Contact information updated successfully"
  );

  return (
    <>
      {(loadingSubmit || loadingFetch) && <Spinner isSpinner={true} />}
      <EditContactInformationForm
        fields={formdata}
        values={values}
        errors={errors}
        handleChange={handleChange}
        handleSubmit={(e) => handleSubmit(e, values)}
        loading={loadingSubmit}
      />
    </>
  );
};

export default EditContactInformation;
